export default {
    scrollToTop() {
        // Only works when displayed in iFrame
        window.parent.postMessage({action: 'scrollTo', x: 0, y: 0}, "*");
    },
    updateParentUrl(data = []) {
        window.parent.postMessage({action: 'updateUrl', query: data}, "*");
    }
}